// extracted by mini-css-extract-plugin
module.exports = {"label":"KeywordSearchGroupFormKeywordField_label__2oWC_","sending":"KeywordSearchGroupFormKeywordField_sending__1xLoq"};